/** Enumeration of all possible callout component types */
export enum CalloutComponentType {
  CONTENT = 'content',
  INPUT_ADDRESS = 'address',
  INPUT_AUDIO_RECORDER = 'audiorecorder',
  INPUT_CHECKBOX = 'checkbox',
  INPUT_CURRENCY = 'currency',
  INPUT_DATE_TIME = 'datetime',
  INPUT_EMAIL = 'email',
  INPUT_FILE = 'file',
  INPUT_NUMBER = 'number',
  INPUT_PHONE_NUMBER = 'phoneNumber',
  INPUT_SELECT = 'select',
  INPUT_SELECTABLE_RADIO = 'radio',
  INPUT_SELECTABLE_SELECTBOXES = 'selectboxes',
  INPUT_SIGNATURE = 'signature',
  INPUT_TEXT_AREA = 'textarea',
  INPUT_TEXT_FIELD = 'textfield',
  INPUT_TIME = 'time',
  INPUT_URL = 'url',
  NESTABLE_PANEL = 'panel',
  NESTABLE_TABS = 'tabs',
  NESTABLE_WELL = 'well',
}
